import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt } from 'react-icons/fa';

const supportFAQs = {
    vehicleInventory: [
        { 
            question: "How do I check the availability of a specific vehicle?", 
            answer: "Visit our online inventory page or contact our sales team." 
        },
        { 
            question: "Are the prices listed online final?", 
            answer: "Prices may vary based on promotions, financing options, and features." 
        },
        { 
            question: "Do you offer financing options for purchasing a vehicle?", 
            answer: "Yes, we have multiple financing solutions available." 
        },
        { 
            question: "Can I schedule a test drive online?", 
            answer: "Yes! Use our online booking form to schedule a test drive." 
        },
        { 
            question: "How does the trade-in process work?", 
            answer: "Bring your vehicle for evaluation and get a market value offer." 
        },
        { 
            question: "What warranty options are available for vehicles?", 
            answer: "We provide manufacturer and extended warranty options." 
        },
    ],
    financingOptions: [
        { 
            question: "How does the financing process work?", 
            answer: "Fill out our online application or visit our dealership." 
        },
        { 
            question: "What credit score is needed for financing?", 
            answer: "We offer financing for all credit profiles." 
        },
        { 
            question: "Is a down payment required?", 
            answer: "Not always, but it can reduce your monthly payments." 
        },
        { 
            question: "What are the available financing terms?", 
            answer: "Terms range from 24 to 72 months." 
        },
        { 
            question: "Can I use my trade-in as a down payment?", 
            answer: "Yes, your trade-in can be used towards a new vehicle." 
        },
        { 
            question: "Can I get pre-approved for financing?", 
            answer: "Yes! Use our online pre-approval form." 
        },
    ],
    maintenanceGuides: [
        { 
            question: "How often should I service my vehicle?", 
            answer: "It is recommended to service your vehicle every 5,000 to 7,500 miles or as specified in the owner's manual." 
        },
        { 
            question: "What type of oil should I use for my car?", 
            answer: "Refer to your vehicle’s manual for the recommended oil type, which may vary based on engine type and climate." 
        },
        { 
            question: "How can I improve my vehicle’s fuel efficiency?", 
            answer: "Maintain proper tire pressure, avoid excessive idling, and follow regular maintenance schedules." 
        },
        { 
            question: "When should I replace my car’s battery?", 
            answer: "Most car batteries last between 3 to 5 years; get it tested regularly to avoid unexpected failures." 
        },
        { 
            question: "What are the signs that my brakes need servicing?", 
            answer: "Squeaking noises, reduced braking power, or vibrations while braking indicate the need for servicing." 
        },
        { 
            question: "How do I check my tire pressure?", 
            answer: "Use a tire pressure gauge and compare the reading with the recommended pressure in your owner's manual or driver-side door sticker." 
        },
    ],
    tradeInEvaluation: [
        { 
            question: "How do I get my vehicle appraised for trade-in?", 
            answer: "Visit our dealership for an in-person appraisal or use our online trade-in evaluation tool." 
        },
        { 
            question: "What factors affect my vehicle’s trade-in value?", 
            answer: "Condition, mileage, market demand, and maintenance history all influence trade-in value." 
        },
        { 
            question: "Can I trade in my car if I still owe money on it?", 
            answer: "Yes, we can help you settle your remaining loan balance and apply the trade-in value toward your new purchase." 
        },
        { 
            question: "Do I need to provide service records for my trade-in?", 
            answer: "While not required, providing service records can help increase your vehicle’s value." 
        },
        { 
            question: "Can I trade in a leased vehicle?", 
            answer: "Yes, we can assess your leased vehicle and help with the buyout or trade-in process." 
        },
        { 
            question: "How long does the trade-in process take?", 
            answer: "The process typically takes less than an hour, including appraisal and offer finalization." 
        },
    ],
    scheduleTestDrive: [
        { 
            question: "How do I schedule a test drive?", 
            answer: "You can schedule a test drive online through our booking form or contact our sales team." 
        },
        { 
            question: "Do I need to bring anything for a test drive?", 
            answer: "Yes, bring a valid driver's license and any required insurance documents." 
        },
        { 
            question: "How long does a test drive last?", 
            answer: "Test drives typically last between 15 to 30 minutes, depending on the vehicle and route." 
        },
        { 
            question: "Can I test drive multiple vehicles?", 
            answer: "Yes! Let our team know which models you're interested in, and we'll arrange test drives for each." 
        },
        { 
            question: "Is there a fee for scheduling a test drive?", 
            answer: "No, test drives are completely free and come with no obligation to purchase." 
        },
        { 
            question: "Can I schedule a test drive for the weekend?", 
            answer: "Yes, test drives are available on weekends, but we recommend booking in advance to secure a slot." 
        },
    ],

    dealershipLocations: [
        { 
            question: "Where are your dealership locations?", 
            answer: "You can find our dealership locations on our website's 'Find a Dealer' page." 
        },
        { 
            question: "Do all locations have the same inventory?", 
            answer: "Inventory may vary by location, so we recommend checking online or calling ahead." 
        },
        { 
            question: "What are the dealership hours of operation?", 
            answer: "Dealership hours vary by location, but most are open from 9 AM to 7 PM Monday through Saturday." 
        },
        { 
            question: "Do all locations offer test drives?", 
            answer: "Yes, all of our dealership locations offer test drives. Scheduling in advance is recommended." 
        },
        { 
            question: "Can I get my vehicle serviced at any location?", 
            answer: "Yes, our certified service centers are available at all dealership locations." 
        },
        { 
            question: "How can I contact my nearest dealership?", 
            answer: "Use our website’s 'Find a Dealer' tool to get contact details for your nearest location." 
        },
    ],
    customerSupport: [
        { 
            question: "How can I contact customer support?", 
            answer: "You can reach our customer support via phone, email, or live chat on our website." 
        },
        { 
            question: "What are the customer support hours?", 
            answer: "Our support team is available from 8 AM to 8 PM, Monday to Friday, and 9 AM to 5 PM on weekends." 
        },
        { 
            question: "Can I get support in different languages?", 
            answer: "Yes, our customer support is available in multiple languages. Please specify your preferred language when calling." 
        },
        { 
            question: "How do I report an issue with my vehicle?", 
            answer: "You can report an issue through our online support form or visit your nearest dealership for assistance." 
        },
        { 
            question: "Can I track my service request?", 
            answer: "Yes, you can track your service request status through your account on our website." 
        },
        { 
            question: "What should I do if I am unsatisfied with the support provided?", 
            answer: "If you're not satisfied with the support received, you can escalate the issue by requesting a manager review." 
        },
    ],

    roadsideAssistance: [
        { 
            question: "How do I request roadside assistance?", 
            answer: "Call our 24/7 roadside assistance hotline or request help through our mobile app." 
        },
        { 
            question: "What services are covered under roadside assistance?", 
            answer: "We offer towing, jump-starts, flat tire changes, lockout assistance, and fuel delivery." 
        },
        { 
            question: "Is roadside assistance available nationwide?", 
            answer: "Yes, our roadside assistance is available across the country, 24/7." 
        },
        { 
            question: "Is roadside assistance free?", 
            answer: "Roadside assistance is free for vehicles under warranty. Otherwise, charges may apply." 
        },
        { 
            question: "How long does it take for assistance to arrive?", 
            answer: "Arrival times vary by location but typically range from 30 to 60 minutes." 
        },
        { 
            question: "Can I get roadside assistance for someone else’s vehicle?", 
            answer: "Yes, if you are a registered member of our roadside assistance program, you can request help for another vehicle." 
        },
    ],
};

const supportContacts = [
    {
        id: 1, 
        icon: <FaMapMarkedAlt />,
        title: 'Visit Us',
        content: ['PrimeCars Support Center, 123 Automotive District'],
    },
    {
        id: 2, 
        icon: <FaPhoneAlt />,
        title: 'Call Support',
        content: ['+123-456-7890', '+111-222-333'],
    },
    { 
        id: 3,
        icon: <FaEnvelope />,
        title: 'Support Email',
        content: ['support@example.com', 'help@example.com'],
    },
    {
        id: 4,
        icon: <FaClock />,
        title: 'Support Hours',
        content: ['Mon - Fri: 7 AM - 7 PM', 'Sat - Sun: 8 AM - 6 PM'],
    },
];

export { supportFAQs, supportContacts }